import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "activity_space",
  "use": "activity_space-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"activity_space\"><path d=\"M256 128c-47.104 0-85.3504 38.1952-85.3504 85.3504V896A42.6496 42.6496 0 0 0 256 896v-213.3504h588.9536c38.4 0 60.5184-43.52 37.9392-74.5472l-147.456-202.752 147.456-202.8032a46.9504 46.9504 0 0 0-37.888-74.5472H256z\" fill=\"#45BF8D\" p-id=\"8818\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol